import { NgModule } from '@angular/core';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';

/**
 * indexed db schema for jobs
 */
const dbJobSchema = [{ name: 'id', keypath: 'id', options: { unique: true } }];

/**
 * indexed db schema for images of meters
 */
const dbImageSchema = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'fileName', keypath: 'fileName', options: { unique: true } },
  { name: 'content', keypath: 'content', options: { unique: false } },
  { name: 'timestamp', keypath: 'timestamp', options: { unique: false } },
  { name: 'uploaded', keypath: 'uploaded', options: { unique: false } },
];

/**
 * indexed db schema for readings of counters
 */
const dbReadingSchema = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  {
    name: 'jobMeterCounterId',
    keypath: 'jobMeterCounterId',
    options: { unique: true },
  },
  { name: 'content', keypath: 'content', options: { unique: false } },
  { name: 'timestamp', keypath: 'timestamp', options: { unique: false } },
];

/**
 * indexed db job schema for timestamp of last jobs-synchronisation
 */
const dbSyncTimestampSchema = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'timestamp', keypath: 'timestamp', options: { unique: false } },
];

/**
 * indexed db resultLines schema for resultLines
 */
const dbResultLinesSchema = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'lines', keypath: 'lines', options: { unique: false } },
  { name: 'readingId', keypath: 'readingId', options: { unique: false } },
  { name: 'jobId', keypath: 'jobId', options: { unique: false } },
];

const dbWorkflowSchema = [
  { name: 'type', keypath: 'type', options: { unique: true } },
];

const dbTaskSchema = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'url', keypath: 'url', options: { unique: false } },
  { name: 'body', keypath: 'body', options: { unique: false } },
  { name: 'isImage', keypath: 'isImage', options: { unique: false } },
  { name: 'method', keypath: 'method', options: { unique: false } },
  { name: 'header', keypath: 'header', options: { unique: false } },
  { name: 'fileName', keypath: 'fileName', options: { unique: false } },

];

/**
 * NGX IndexedDB database configuration
 */
const dbConfig: DBConfig = {
  name: 'ZAppDB',
  version: 3,
  objectStoresMeta: [
    {
      store: 'jobs',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: dbJobSchema,
    },
    {
      store: 'lastSync',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: dbSyncTimestampSchema,
    },
    {
      store: 'images',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: dbImageSchema,
    },
    {
      store: 'resultLines',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: dbResultLinesSchema,
    },
    {
      store: 'workflows',
      storeConfig: { keyPath: 'type', autoIncrement: false },
      storeSchema: dbWorkflowSchema,
    },
    {
      store: 'tasks',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: dbTaskSchema,
    },
  ],
};

@NgModule({
  imports: [NgxIndexedDBModule.forRoot(dbConfig)],
})
export class IndexedDbModule {
}
